import { Link } from "react-router-dom";
import { FiInstagram, FiArrowUp } from "react-icons/fi";
import styles from "./Footer.module.css";

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <footer className={styles.footer}>
      <div className={styles.divider} />
      <div className={styles.inner}>
        <div className={styles.brand}>
          <h3 className={styles.logo}>
            <span className={styles.accent}>Travel</span>with
            <span className={styles.accent}>Avara</span>
          </h3>
          <p className={styles.tagline}>
            Exploring the world, one story at a time.
          </p>
        </div>

        <div className={styles.linksSection}>
          <div className={styles.linkGroup}>
            <h4>Navigate</h4>
            <Link to="/">Home</Link>
            <Link to="/blog">Stories</Link>
            <Link to="/about">About</Link>
          </div>
          <div className={styles.linkGroup}>
            <h4>Connect</h4>
            <a
              href="https://instagram.com/Travelwithavara"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FiInstagram size={14} /> Instagram
            </a>
          </div>
        </div>

        <button
          className={styles.scrollTop}
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <FiArrowUp size={20} />
        </button>
      </div>

      <div className={styles.bottom}>
        <p>&copy; {new Date().getFullYear()} TravelWithAvara. All rights reserved.</p>
      </div>
    </footer>
  );
}
